import { useState } from 'react';
import { useParams } from 'react-router-dom';
import LandingBody from './components/landingBody';

const Landing = () => {
  const { id } = useParams<{ id: string }>();
  const [type, setType] = useState<string>('');
  return <LandingBody id={id || ''} setType={setType} />;
};

export default Landing;
